export default "__VITE_ASSET__D4PcVBdj__"